/** Local invalidation only. No conversation text is sent with a speech mint. */
export type SpeechConversation = { threadId: string | null; languages: string[] | null };

type ContextMessage = {
  id: string;
  role: string;
  content: readonly { type: string; text?: string }[];
};

export function speechConversationRevision(messages: readonly ContextMessage[]): string {
  return JSON.stringify(
    messages
      .filter((message) => message.role === 'user')
      .slice(-12)
      .map((message) => ({
        id: message.id,
        text: message.content
          .filter((part) => part.type === 'text')
          .map((part) => part.text ?? '')
          .join('')
          .slice(0, 1200),
      })),
  );
}

/** Per mounted owner/chat, never shared between people or conversations. */
export function createSpeechLanguageContext(
  fetchHints: (threadId: string) => Promise<{ codes: string[] }>,
) {
  let generation = 0;
  let languages: string[] | null = null;
  return {
    current: () => languages,
    async refresh(threadId: string) {
      const request = ++generation;
      try {
        const value = await fetchHints(threadId);
        if (
          request === generation &&
          Array.isArray(value.codes) &&
          value.codes.every((code) => typeof code === 'string')
        )
          languages = [...new Set(value.codes)].sort();
      } catch {
        /* A failed prefetch leaves minting's normal fallback intact. */
      }
    },
    clear() {
      generation += 1;
      languages = null;
    },
  };
}
